import {
    createFeatureSelector,
    createReducer,
    createSelector,
    on,
    StoreModule,
} from '@ngrx/store';
import { changeSidenavState } from './actions/sidenav.actions';

export const mobileSidenavFeatureKey = 'mobile-sidenav';

export interface MobileSidenavState {
    isSidenavOpen: boolean;
}

export const initialState: MobileSidenavState = {
    isSidenavOpen: false,
};

export const mobileSidenavReducer = createReducer(
    initialState,
    on(changeSidenavState, (state) => {
        return {
            ...state,
            isSidenavOpen: !state.isSidenavOpen,
        };
    })
);

export const getMobileSidenavFeatureState =
    createFeatureSelector<MobileSidenavState>(mobileSidenavFeatureKey);

export const getIsSidenavOpen = createSelector(
    getMobileSidenavFeatureState,
    (state) => state.isSidenavOpen
);

export const mobileSidenavStoreModule = StoreModule.forFeature(
    mobileSidenavFeatureKey,
    mobileSidenavReducer
);
